import {Component, effect, inject, input, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Dialog} from 'primeng/dialog';
import {DatePicker} from 'primeng/datepicker';
import {Button} from 'primeng/button';
import {TaTemplateSummary} from '../../../api';
import {TemplateDatasource} from '../../../datasources/template.datasource';
import {TaAppStore} from '../../../state/clcta-store';

/** Asks for the start date, then raises a TA from the template. Day 1 lands on that date. */
@Component({
  selector: 'create-ta-from-template-dialog',
  imports: [
    FormsModule,
    Dialog,
    DatePicker,
    Button,
  ],
  templateUrl: './create-ta-from-template-dialog.html',
})
export class CreateTaFromTemplateDialog {
  private templateDatasource = inject(TemplateDatasource);
  store = inject(TaAppStore);

  template = input<TaTemplateSummary | undefined>();
  // False when a booking officer raises the TA for someone else.
  forSelf = input.required<boolean>();
  visible = model<boolean>(false);
  startDate = signal<Date | null>(null);

  constructor() {
    // A fresh date each time it opens.
    effect(() => {
      if (this.visible()) {
        this.startDate.set(null);
      }
    });
  }

  create(): void {
    const id = this.template()?.id;
    const date = this.startDate();
    if (!id || !date) return;
    this.visible.set(false);
    this.templateDatasource.createTaFromTemplate(id, date, this.forSelf());
  }
}
